var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { Fragment, createElement, Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import * as route from '../route/routes';
import { AlertContainer } from './organisms/alert_container';
import { PageLoading } from './organisms/page_loading';
/**
 * view/pages 以下の画面コンポーネントをルーティング
 */
export const Root = React.memo(({ pageProvider, routeController, alertContainerVM }) => {
    const pp = pageProvider;
    const domainFactory = pageProvider.domainFactory;
    const accountService = pageProvider.domainFactory.AccountService();
    const location = useLocation();
    const [loading, setLoading] = React.useState(true);
    const authorization = () => __awaiter(void 0, void 0, void 0, function* () {
        // LP で新規登録を行い、そのまま遷移してきた場合にログイン状態として扱う
        const searchParams = new URLSearchParams(location.search);
        const isRegistered = searchParams.get('registered') === '1';
        if (accountService.loggedIn || isRegistered) {
            return routeController.authorizationWithForbiddenRedirect().then((v) => {
                return v.userId;
            });
        }
        return null;
    });
    React.useEffect(() => {
        let userID;
        authorization()
            .then((res) => {
            userID = res;
        })
            .catch((e) => {
            if (e.isForbiddenError) {
                // authorization()でforbiddenエラーの時は、userIDを受け取れないので、fetchMeで受け取ってから、実行
                return accountService.fetchMe().then((me) => {
                    userID = me.id;
                });
            }
        })
            .finally(() => {
            domainFactory.buildWithUserID(userID);
            setLoading(false);
        });
    }, []);
    React.useEffect(() => {
        if (!loading) {
            routeController.onLocationChanged(location, domainFactory.Tracker());
        }
        // authorization()完了時にonLocationChanged()を実行したいので、loadingも検知対象に入れてる
    }, [location, loading]);
    if (loading)
        return null;
    return (React.createElement(Fragment, null,
        React.createElement(Suspense, { fallback: React.createElement(PageLoading, null) },
            React.createElement(Routes, null,
                React.createElement(Route, Object.assign({}, route.MAINTENANCE, { element: createElement(pp.Maintenance) })),
                React.createElement(Route, Object.assign({}, route.CC_REGISTRATION, { element: createElement(pp.PaymentRegistratoin) })),
                React.createElement(Route, Object.assign({}, route.CALLBACK_LINE, { element: createElement(pp.LineCallback) })),
                React.createElement(Route, Object.assign({}, route.CALLBACK_APPLE, { element: createElement(pp.AppleCallback) })),
                React.createElement(Route, Object.assign({}, route.CALLBACK_AMAZON_PAY, { element: createElement(pp.AmazonPayCallback) })),
                React.createElement(Route, Object.assign({}, route.CALLBACK_AMAZON_PAY_FOR_SIGNUP, { element: createElement(pp.AmazonPayForSignupCallback) })),
                React.createElement(Route, Object.assign({}, route.SIGNUP, { element: createElement(pp.SignUp) })),
                React.createElement(Route, Object.assign({}, route.SIGNUP_V2, { element: createElement(pp.SignUpV2) })),
                React.createElement(Route, Object.assign({}, route.SIGNIN, { element: createElement(pp.SignIn) })),
                React.createElement(Route, Object.assign({}, route.EMAIL_VERIFICATION, { element: createElement(pp.EmailVerification) })),
                React.createElement(Route, Object.assign({}, route.PASSWORD_RESET_REQUEST, { element: createElement(pp.PasswordResetRequestPage) })),
                React.createElement(Route, Object.assign({}, route.PASSWORD_RESET, { element: createElement(pp.PasswordResetPage) })),
                React.createElement(Route, Object.assign({}, route.MAGAZINE_UNSUBSCRIBE, { element: createElement(pp.MagazineUnsubscribePage) })),
                React.createElement(Route, Object.assign({}, route.LP_IFRAME, { element: createElement(pp.LPIframePage) })),
                React.createElement(Route, Object.assign({}, route.CC_REGISTRATION, { element: createElement(pp.PaymentRegistratoin) })),
                React.createElement(Route, Object.assign({}, route.CALLBACK_APPLE, { element: createElement(pp.AppleCallback) })),
                React.createElement(Route, Object.assign({}, route.CALLBACK_APPLE, { element: createElement(pp.AppleCallback) })),
                React.createElement(Route, Object.assign({}, route.TV_LOGIN, { element: createElement(pp.TvLoginPage) })),
                React.createElement(Route, Object.assign({}, route.SIGNUP_MATCHING_ASSESSMENT, { element: createElement(pp.SignupMatchingAssessmentPage) })),
                React.createElement(Route, { path: `${route.TOP.path}*`, element: createElement(pp.Main) }))),
        React.createElement(AlertContainer, { vm: alertContainerVM })));
});
